import { useTranslation } from "react-i18next";

interface ProductUsageTotalsProps {
  matches: number;
  calculations: number;
}

const ProductUsageTotals = ({
  matches,
  calculations,
}: ProductUsageTotalsProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-3 border-t border-yellow-200 pt-2 text-xs font-medium text-yellow-800">
      {t("productEditor.productUsageTotalImpact", { matches, calculations })}
    </div>
  );
};

export default ProductUsageTotals;
